import {
  useMutationCreateCancellationReason,
  useMutationDeleteCancellationReason,
  useMutationEditCancellationReason,
  useQueryGetCancellationReasonList,
} from "@gymflow/api";
import { ManageModal } from "apps/portal/src/components/atoms";
import { useClubSettings } from "apps/portal/src/providers";
import useGymflowModels from "apps/portal/src/store";
import { useTranslation } from "react-i18next";

type CancellationReasonsModalProps = {
  onHide: () => void;
};

export const CancellationReasonsModal = ({
  onHide,
}: CancellationReasonsModalProps) => {
  const { t } = useTranslation();
  const { clubId } = useClubSettings();
  const { api } = useGymflowModels();

  const { data: cancellationReasons, isLoading: isLoadingCancellationReason } =
    useQueryGetCancellationReasonList({
      api,
      clubId,
    });

  const {
    mutateAsync: mutateAsyncCreateCancellationReason,
    isPending: isPendingCreateCancellationReason,
  } = useMutationCreateCancellationReason({ api });

  const {
    mutateAsync: mutateAsyncEditCancellationReason,
    isPending: isPendingEditCancellationReason,
  } = useMutationEditCancellationReason({ api });

  const { mutateAsync: mutateAsyncDeleteCancellationReason } =
    useMutationDeleteCancellationReason({ api });

  return (
    <ManageModal
      toastMessage={t(
        "components.cancelMembershipSidebar.formCancellationReasonSelect.cancellationReasonsModal.toastMessage",
      )}
      title={t(
        "components.cancelMembershipSidebar.formCancellationReasonSelect.cancellationReasonsModal.title",
      )}
      description={t(
        "components.cancelMembershipSidebar.formCancellationReasonSelect.cancellationReasonsModal.description",
      )}
      onHide={() => onHide()}
      items={cancellationReasons ?? []}
      isLoadingList={isLoadingCancellationReason}
      isPendingAdd={isPendingCreateCancellationReason}
      isPendingEdit={isPendingEditCancellationReason}
      onAdd={async (name) => {
        await mutateAsyncCreateCancellationReason({ clubId, name });
      }}
      onEdit={async (id, name) => {
        await mutateAsyncEditCancellationReason({
          clubId,
          reasonId: id,
          name,
        });
      }}
      onDeleteItem={async (item) => {
        await mutateAsyncDeleteCancellationReason({
          clubId,
          reasonId: item.id,
        });
      }}
    />
  );
};
